import { requestGet, requestPost } from '@/common/request';

// 获取表单数据
export const fetchFormData = async (query) => {
  return await requestPost('/generic/yxFormReadService/queryFormSetDetail', query);
};
// 报名接口
export const ApplyForm = async (query) => {
  return await requestPost('/generic/yxApplyWriteService/singleApply', query);
};
// 换品接口
export const ApplyAgainForm = async (query) => {
  return await requestPost('/generic/yxApplyWriteService/changeApply', query);
};
// 拉取erp拥有资源数接口
export const getOwnerResource = async (query) => {
  return await requestPost('/generic/yxAssignReadService/queryOwnerResource', query);
};
// 校验erp
export const validateErp = async (query) => {
  return await requestGet('/pin/valid', query);
};
// 待报名列表
export const queryExtendInfo = async (query) => {
  return await requestPost('/generic/yxActivityReadService/queryExtendInfo', query);
};

// 换品回显的数据
export const fetchApplyData = async (query) => {
  return await requestPost('/generic/yxApplyReadService/queryForList', query);
};
// 经海路标签校验
export const vaildTag = async (query) => {
  return await requestPost('/generic/yxApplyReadService/queryUnitGroupInfo', query);
};
